export default {
  getRamUserList: {
    url: "/mock/ram/user/list",
    method: "get",
    desc: "用户分页查询",
    topTips: true
  },
  getUserGroupList: {
    url: "/mock/ram/user-group/list",
    method: "get",
    desc: "用户组分页查询",
    topTips: true
  }
};
